import styled, { css } from '../theme/styled-components';

const Base = css`
  padding: calc(${props => props.theme.spacings.tiny} / 2);
  border: 1px solid ${props => props.theme.colors.border.dark.base};
`;

export const Input = styled.input`
  ${Base}
`;
export const Textarea = styled.textarea`
  ${Base}
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  margin-top: ${props => props.theme.spacings.tiny};
  margin-bottom: calc(${props => props.theme.spacings.tiny} / 2);
`;
